import { render, staticRenderFns } from "./VacanciesCompanyAdvantagesBlock.vue?vue&type=template&id=4d571c8c&scoped=true&"
import script from "./VacanciesCompanyAdvantagesBlock.vue?vue&type=script&lang=js&"
export * from "./VacanciesCompanyAdvantagesBlock.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesCompanyAdvantagesBlock.vue?vue&type=style&index=0&id=4d571c8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d571c8c",
  null
  
)

export default component.exports